module.exports = __webpack_public_path__ + "static/media/500.846fe400.svg";